const apiUrl = process.env.REACT_APP_API_URL;

export async function UseItem(idInstance: number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/item/use`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idInstance })
        });
        return await response.ok;
    } catch (error) {
        console.error("Error using item:", error);
        return false;
    }
}
